import React from "react"
import { motion, Variants } from "framer-motion"

interface AnimatedGroupProps extends React.ComponentProps<typeof motion.div> {
  variants?: Variants
  children: React.ReactNode
}

const defaultVariants: Variants = {
  container: {
    visible: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  },
}

export function AnimatedGroup({ children, variants, ...props }: AnimatedGroupProps) {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{
        ...defaultVariants,
        ...variants,
      }}
      {...props}
    >
      {children}
    </motion.div>
  )
} 